import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_CONSIGNMENT_STATUS_LIST, GET_ASN_LIST, GET_STAKEHOLDER_CATEGORY, GET_ASN_CORRECTION_LIST, APPROVE_ASN_CORRECTION, SEND_BACK_ASN_CORRECTION } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { loaderService } from "../../../common/custom-loader/loader-service";
import moment from 'moment';
import { Container, Button, Box, TextField, Tooltip, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, CardContent, Grid, FormControl, InputLabel, Select, Tab, Paper } from '@mui/material'
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { ApproveIcon, CloseIcon, EditIcon, SubmitIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";

function AsnSendForCorrection() {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [asnDetails, setAsnDetails] = useState([]);
    const [selectedAsnData, setSelectedAsnData] = useState(null);
    const [viewMode, setViewMode] = useState(false);
    const [asnList, setasnList] = useState([]);
    const [bulkApproveAsnCorrection, setbulkApproveAsnCorrection] = useState();
    const [tabValueMaterial, setTabValueMaterial] = useState("RawBamboo");
    const [isApiCalled, setIsApiCalled] = useState(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const handleMaterialTabChange = (_e, newValue) => {
        setTabValueMaterial(newValue);
        setasnList([])
    };

    useEffect(() => {
        getAsnCorrectionDetails(tabValueMaterial);
    }, [tabValueMaterial]);

    const onViewDetails = (row) => {
        setSelectedAsnData(row);
        setViewMode(true);
    }

    const handleBackToList = () => {
        setViewMode(false);
        setSelectedAsnData(null);
        getAsnCorrectionDetails(tabValueMaterial); // Refreshes the list on back click
    };

    const getAsnCorrectionDetails = (materialType) => {
        const data = {
            roleType: localStorage.getItem("role") || "",
            materialType: materialType,
            //    estApproved: value === "pending" ? false : true,
            isSentBackForAsnCorrection: false,
        };

        const headers = { Authorization: "Bearer " + getLocalStorageItem("id_token") };

        loaderService.showLoader();
        apiClient
            .post(GET_ASN_CORRECTION_LIST, data, { headers })
            .then((res) => setAsnDetails(res.data.asnList || []))
            .catch((err) => {
                console.error(err);
                toast.error(err?.message || "Failed to load ASN list");
            })
            .finally(() => loaderService.hideLoader());
    };

    const columns = [
        { field: 'asnNo', headerName: 'ASN ID#', width: 120 },
        { field: 'consignmentNo', headerName: 'Consignment No', width: 130 },
        { field: 'challanNo', headerName: 'Delivery Challan Number', width: 180 },
        { field: 'grnNo', headerName: 'GRN Number', width: 150 },
        { field: 'sesNo', headerName: 'SES Number', width: 150 },
        // { field: 'poNumber', headerName: 'PO Number', width: 150 },
        {
            field: 'stakeholderSourceUrn', headerName: 'Source URN', width: 150,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn
        },
        {
            field: 'stakeholderSourceName', headerName: 'Source Name', width: 180,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName
        },
        { field: 'consignmentDestinationStakeholderUrn', headerName: 'Destination URN', width: 150 },
        {
            field: 'consignmentDestinationName', headerName: 'Destination Name', width: 200,
            renderCell: (params) => {
                return (
                    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                        {params.value}
                    </div>
                )
            },
            valueGetter: (params) => params.value
        },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 220 },
        { field: 'asnStatus', headerName: 'ASN Status', width: 220 },
        {
            field: 'asnDate', headerName: 'ASN Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        // {
        //     field: 'pickupNetWeight', headerName: 'ASN Quantity', width: 120,
        // },
        {
            field: 'lastComment', headerName: 'Previous Comment', width: 220,
        },
        {
            field: 'Action', width: 150,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="View">
                        <IconButton
                            // disabled={cellValues?.row?.grnNo && cellValues?.row?.isSentBackForAsnCorrection !== true}
                            color="primary"
                            onClick={() => onViewDetails(cellValues.row)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const onConfirmApprove = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await toApproveBulk(true);
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    }

    const onApproveButtonClick = (e) => {
        handleConfirmOpen();
    }

    const toApproveBulk = () => {
        loaderService.showLoader();
        apiClient
            .post(SEND_BACK_ASN_CORRECTION,
                {
                    "asnNumbers": asnList,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setbulkApproveAsnCorrection(response.data);
                getAsnCorrectionDetails(tabValueMaterial);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (bulkApproveAsnCorrection) {
            if (bulkApproveAsnCorrection.isSuccess === true) {
                toast.success(bulkApproveAsnCorrection?.message)
                setasnList([])
            }
            else {
                toast.error(bulkApproveAsnCorrection?.message ? bulkApproveAsnCorrection?.message : "Error")
            }
        }
    }, [bulkApproveAsnCorrection]);

    const convertMtToKgString = (mtValue) => {
        const numericValue = parseFloat(mtValue);
        if (isNaN(numericValue)) return '0';
        return (numericValue * 1000).toLocaleString();
    };

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT06</p>}

                {viewMode ? (
                    <>
                        <Stack direction="row" mb={2} justifyContent="space-between" alignItems="center">
                            <Typography variant="h4" gutterBottom>
                                ASN Details - {selectedAsnData?.asnNo}
                            </Typography>
                            <Button variant="outlined" color="secondary" onClick={handleBackToList}>
                                Back to List
                            </Button>
                        </Stack>

                        <Card sx={{ p: 3 }}>
                            <CardContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Gross weight (in KG) measured"
                                            fullWidth
                                            variant="outlined"
                                            value={convertMtToKgString(selectedAsnData?.destinationGrossWeight)}
                                            InputProps={{ readOnly: true }}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Tare weight (in KG) measured"
                                            fullWidth
                                            variant="outlined"
                                            value={convertMtToKgString(selectedAsnData?.destinationTareWeight)}
                                            InputProps={{ readOnly: true }}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Net weight(in KG) as per measurement"
                                            fullWidth
                                            variant="outlined"
                                            value={convertMtToKgString(selectedAsnData?.destinationNetWeight)}
                                            InputProps={{ readOnly: true }}
                                            disabled
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                p: 2.5,
                                                bgcolor: "grey.50",
                                                borderRadius: 2,
                                            }}
                                        >
                                            <Typography
                                                variant="subtitle2"
                                                color="text.secondary"
                                                gutterBottom
                                            >
                                                Previous Comment
                                            </Typography>

                                            <Typography variant="body1">
                                                {selectedAsnData?.lastComment || "No comments available."}
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>
                    </>
                ) : (
                    <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                            <Typography variant="h4" gutterBottom>
                                Send Back for ASN Correction
                            </Typography>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                <Stack direction="row" spacing={1}>
                                    <Button variant="contained" disabled={asnList?.length < 1} onClick={(e) => onApproveButtonClick(e)} endIcon={<SubmitIcon />}>
                                        Send For Correction
                                    </Button>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Card>
                            <TabContext value={tabValueMaterial}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: "whitesmoke" }}>
                                    <TabList onChange={handleMaterialTabChange} >
                                        <Tab label='Raw Bamboo' value="RawBamboo" />
                                        <Tab label='Chip Bamboo' value="ChipBamboo" />
                                    </TabList>
                                </Box>
                                <TabPanel value="RawBamboo" >
                                    <Box style={{ height: 500, width: '100%' }}>
                                        {
                                            asnDetails &&
                                            <DataGrid rows={asnDetails}
                                                getRowHeight={() => 'auto'}
                                                sx={{
                                                    [`& .${gridClasses.cell}`]: {
                                                        py: 1,
                                                    },
                                                    '& .MuiDataGrid-cell': {
                                                        whiteSpace: 'normal !important',
                                                        wordWrap: 'break-word !important',
                                                    },
                                                }}
                                                columns={columns}
                                                pageSize={10}
                                                checkboxSelection
                                                isRowSelectable={(params) => {
                                                    const r = params.row;
                                                    const notSentBack = r?.isSentBackForAsnCorrection !== true;
                                                    return notSentBack;
                                                }}
                                                components={{ Toolbar: QuickSearchToolbar }}
                                                onSelectionModelChange={(newSelection) => {
                                                    setasnList(newSelection.map(row => {
                                                        let asnNo = ""
                                                        asnDetails.forEach(item => {
                                                            if (row === item.id) {
                                                                asnNo = item.asnNo;
                                                            }
                                                        })
                                                        return asnNo;
                                                    }));
                                                }}
                                            />
                                        }
                                    </Box>
                                </TabPanel>
                                <TabPanel value="ChipBamboo">
                                    <Box style={{ height: 500, width: '100%' }}>
                                        {
                                            asnDetails &&
                                            <DataGrid rows={asnDetails}
                                                getRowHeight={() => 'auto'}
                                                sx={{
                                                    [`& .${gridClasses.cell}`]: {
                                                        py: 1,
                                                    },
                                                    '& .MuiDataGrid-cell': {
                                                        whiteSpace: 'normal !important',
                                                        wordWrap: 'break-word !important',
                                                    },
                                                }}
                                                columns={columns}
                                                pageSize={10}
                                                checkboxSelection
                                                isRowSelectable={(params) => {
                                                    const r = params.row;
                                                    // const hasGrn =
                                                    //     r?.grnNo !== null &&
                                                    //     r?.grnNo !== undefined &&
                                                    //     r?.grnNo !== "";
                                                    const notSentBack = r?.isSentBackForAsnCorrection !== true;
                                                    return notSentBack;
                                                }}
                                                components={{ Toolbar: QuickSearchToolbar }}
                                                onSelectionModelChange={(newSelection) => {
                                                    setasnList(newSelection.map(row => {
                                                        let asnNo = ""
                                                        asnDetails.forEach(item => {
                                                            if (row === item.id) {
                                                                asnNo = item.asnNo;
                                                            }
                                                        })
                                                        return asnNo;
                                                    }));
                                                }}
                                            />
                                        }
                                    </Box>
                                </TabPanel>
                            </TabContext>
                        </Card>
                    </>
                )}
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Send Back For ASN Correction" />
        </>
    );
}
export default AsnSendForCorrection;
